export enum RAIL_TITLE_CONSTANTS {
  Webisodes = 'Webisodes',
  Clips = 'Clips',
  Promos = 'Promos',
  Mobisodes = 'Mobisodes',
  Trailers = 'Trailers',
  AllEpisodes = 'All Episodes',
  Previews = 'Previews'
}
